<template>
  <div style="width: 100%; height: 100%">
    <el-row>
      <el-form size="small" :inline="true" class="demo-form-inline" style="padding-top: 0; margin-top: 20px">
        <el-form-item label="出库日期：">
          <el-date-picker disabled v-model="searchForm.DATE" type="date" value-format="yyyy-MM-dd" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-table :data="tableData" border stripe style="width: 100%" :span-method="objectSpanMethod" :cell-class-name="tableCellClassName"
        @cell-click="cellClick">
        <el-table-column prop="PRODUCT_CODE" label="产品编码"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称" min-width="100"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="REAL_COUNT" label="实收数量"></el-table-column>
        <el-table-column label="可出库产品">
          <el-table-column prop="ADD_PRODUCT_CODE" label="出库产品编码"></el-table-column>
          <el-table-column prop="ADD_PRODUCT_NAME" label="出库产品名称"></el-table-column>
          <el-table-column prop="ADD_TYPE_UNIT" label="单位"></el-table-column>
          <el-table-column prop="ADD_BATCH" label="批次"></el-table-column>
          <el-table-column prop="ADD_LOCATION_CODE" label="库位" v-if="isComplexWarehouse"></el-table-column>
          <el-table-column prop="ADD_PRODUCTION_DATE" label="生产日期" v-if="isComplexWarehouse"></el-table-column>
          <el-table-column prop="ADD_PRODUCT_COUNT" label="库存数量"></el-table-column>
          <el-table-column prop="ADD_OUT_COUNT" label="补出库数量" width="200" min-width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.ADD_OUT_COUNT" @change="OutCount(scope.row)" oninput="value=value.replace(/[^0-9.]/g,'')">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="REPLENISHMENT_COMMENT" label="补出库备注" width="200" min-width="100">
            <template slot-scope="scope">
              <el-input v-model="scope.row.REPLENISHMENT_COMMENT" />
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="操作" min-width="80" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="addProduct(scope.row)">添加出库产品</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row>
      <el-col>
        <el-button style="float: right; margin-top: 20px" type="primary" @click="submit">提交</el-button>
      </el-col>
    </el-row>
    <!-- 添加出库产品 -->
    <!-- 补出库 -->
    <el-dialog title="补出库" center :visible.sync="addFormVisible" width="1200px">
      <el-form :model="addForm" ref="addForm">
        <el-form-item label="产品名称：" :label-width="formLabelWidth">
          <el-select filterable v-model="addForm.product" style="width: 80%" remote :remote-method="remoteMethod" :clearable="true" :loading="loading"
            @change="insertTable">
            <el-option v-for="(item,index) in productList" :key="index" :value="`${item.BATCH}|${item.LOCATION_ID}`"
              :label="isComplexWarehouse ? `${item.PRODUCT_NAME}  (批次:${item.BATCH}${ item.LOCATION_ID ? ` 库位:${item.LOCATION_CODE}`:''} 生产日期:${item.PRODUCTION_DATE})` : item.PRODUCT_NAME">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table :data="resultData" border stripe>
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="PRODUCT_NAME" label="产品名称"></el-table-column>
        <el-table-column prop="TYPE_UNIT" label="单位"></el-table-column>
        <el-table-column prop="BATCH" label="批次"></el-table-column>
        <el-table-column prop="LOCATION_CODE" label="库位" v-if="isComplexWarehouse"></el-table-column>
        <el-table-column prop="PRODUCTION_DATE" label="生产日期" v-if="isComplexWarehouse"></el-table-column>
        <el-table-column prop="PRODUCT_COUNT" label="剩余库存"></el-table-column>
        <el-table-column prop="OUT_COUNT" label="出库数量" width="100" min-width="100">
          <template slot-scope="scope">
            <el-input v-model="scope.row.OUT_COUNT" @change="OutCount" @input.native="OutCount($event, scope.row)"
              oninput="value=value.replace(/[^0-9.]/g,'')">
            </el-input>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" @click="deleteRecord(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFormVisible = false">取 消</el-button>
        <el-button @click="submitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { addOutFun } from 'api/sellOrder';
import { queryWarehouseFun } from 'api/warehouseManager';
import date from "@/assets/common/date";

export default {
  data() {
    return {
      // 搜索表单
      searchForm: {
        DATE: date(new Date(), '%F')
      },
      // 表格数据
      tableData: [],
      // 补出库搜索列表
      resultData: [],
      // 添加补出库弹框
      addFormVisible: false,
      // 补出库搜索表单
      addForm: {},
      // 获取补出库产品名称列表
      productList: [],
      // 存放订单数据
      addList_row: [],
      rowIndex: '',
      // 单元格合并
      spanArr: [],
      position: 0,
      formLabelWidth: '120px',
      orderID: 0,
      loading: false,
      CAN_MODIFY_PRICE: sessionStorage.getItem('CAN_MODIFY_PRICE'),
      isisdisabled: false,
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),

    };
  },
  computed: {
    isComplexWarehouse() {
      return this.WAREHOUSE_MODE == 2;
    },
  },
  methods: {
    // 取得对应行的index
    tableCellClassName({
      row, column, rowIndex, columnIndex,
    }) {
      row.index = rowIndex;
      column.index = columnIndex;
    },
    cellClick(row, column, cell, event) {
      this.rowIndex = row.index;
    },
    // 添加出库产品 打开模态框
    addProduct(row) {
      this.addList_row = row;
      this.addFormVisible = true;
    },
    // 搜索补出库产品
    remoteMethod(query) {
      if (query !== '') {
        this.loading = true;
        const params = {
          PRODUCT_NAME: query,
          PAGESIZE: 10000,
          PAGEINDEX: 0,
          SHOW: 0,
          FLAG: 0,
          WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
        };
        queryWarehouseFun(params).then((result) => {
          this.loading = false;
          if (result[0].TOTAL_COUNT !== 0) {
            this.productList = [
              ...new Set(
                result[0].OP_ROLE.map((item) => Object.assign(item, { OUT_COUNT: '' })),
              ),
            ];
          } else {
            this.productList = [];
          }
        }).catch((error) => {
          this.loading = false;
          this.$message.show({ text: error, type: 'error' });
        });
      } else {
        this.productList = [];
      }
    },
    insertTable(e) {
      let tmpArr = [];
      tmpArr = this.productList.filter((item) => `${item.BATCH}|${item.LOCATION_ID}` == e);
      this.resultData = this.resultData.concat(tmpArr);
      const newobj = {};
      this.resultData = this.resultData.reduce((preVal, curVal) => {
        if (!newobj[`${curVal.BATCH}|${curVal.LOCATION_ID}`]) newobj[`${curVal.BATCH}|${curVal.LOCATION_ID}`] = preVal.push(curVal);
        return preVal;
      }, []);
    },
    // 删除补出库产品
    deleteRecord(row) {
      const tableArr = this.resultData.filter(
        (item) => `${item.BATCH}|${item.LOCATION_ID}` !== `${row.BATCH}|${row.LOCATION_ID}`,
      );
      this.resultData = tableArr;
    },
    // 添加出库产品
    submitAdd() {
      const tableArr = this.resultData.filter((item) => item.OUT_COUNT != '');
      if (!tableArr.length) {
        this.$message.show({ text: '请填写出库数量', type: 'warning' });
        return false;
      }
      this.resultData = tableArr;
      if (this.resultData.some((val) => val.OUT_COUNT === '0')) {
        this.$message.show({ text: '数量必须大于0', type: 'warning' });
        return false;
      }
      const submitArr = [];
      // 将补出库数据拼接在一起
      this.resultData.forEach((item) => {
        const data = {
          // 出库产品信息
          ADD_PRODUCT_CODE: item.PRODUCT_CODE,
          ADD_PRODUCT_NAME: item.PRODUCT_NAME,
          ADD_TYPE_UNIT: item.TYPE_UNIT,
          ADD_BATCH: item.BATCH,
          ADD_PRODUCT_COUNT: item.PRODUCT_COUNT,
          ADD_OUT_COUNT: item.OUT_COUNT,
          ADD_LOCATION_CODE: item.LOCATION_CODE,
          ADD_LOCATION_ID: item.LOCATION_ID,
          ADD_PRODUCTION_DATE: item.PRODUCTION_DATE,
          // 原订单信息
          PRODUCT_CODE: this.addList_row.PRODUCT_CODE,
          PRODUCT_NAME: this.addList_row.PRODUCT_NAME,
          TYPE_UNIT: this.addList_row.TYPE_UNIT,
          REAL_COUNT: this.addList_row.REAL_COUNT,
          ORDER_DETAIL_ID: this.addList_row.ORDER_DETAIL_ID,
        };
        submitArr.push(data);
      });
      if (!this.tableData[this.rowIndex].ADD_PRODUCT_CODE) {
        this.tableData.splice(this.rowIndex, 1);
      }
      submitArr.forEach((ele) => {
        this.tableData.splice(this.rowIndex, 0, ele);
      });
      this.addFormVisible = false;
      this.submitArr = [];
      this.resultData = [];
      this.spanArr = [];
      this.rowspan();
    },
    submit() {
      if (!this.searchForm.DATE) {
        this.$message.show({ text: '请选择出库日期', type: 'warning' });
        return false;
      }
      let tag = false;
      this.tableData.forEach((ele) => {
        if ('ADD_PRODUCT_CODE' in ele == false) {
          tag = true;
        } else if ('ADD_OUT_COUNT' in ele == false) {
          tag = true;
        } else if ('ADD_BATCH' in ele == false) {
          tag = true;
        }
      });
      if (tag) {
        this.$message.show({ text: '请添加补出库产品', type: 'warning' });
        tag = false;
        return false;
      }
      const PRODUCTS_ARRAY = this.tableData.map((item) => {
        const obj = {
          ORDER_DETAIL_ID: item.ORDER_DETAIL_ID,
          PRODUCT_CODE: item.ADD_PRODUCT_CODE,
          PRODUCT_COUNT: item.ADD_OUT_COUNT == '' ? 0 : item.ADD_OUT_COUNT,
          BATCH: item.ADD_BATCH,
          LOCATION_ID: item.ADD_LOCATION_ID,
        };
        if (item.REPLENISHMENT_COMMENT) obj.REPLENISHMENT_COMMENT = item.REPLENISHMENT_COMMENT;
        return obj;
      });
      if (PRODUCTS_ARRAY.length == []) {
        this.$message.show({ text: '请补充出库产品列表', type: 'warning' });
        return false;
      }
      const params = {
        PRODUCTS_ARRAY,
        ORDER_ID: this.orderID,
        DELIVER_DAY: this.searchForm.DATE,
      };
      addOutFun(params).then((result) => {
        this.$message.show({ text: '操作成功', type: 'success' });
        this.$router.back();
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    OutCount(row) {
      if (Number(row.OUT_COUNT) > Number(row.PRODUCT_COUNT)) {
        row.OUT_COUNT = 0;
        this.$message.show({ text: '出库数量大于库存数量', type: 'warning' });
        return false;
      }
      if (Number(row.ADD_OUT_COUNT) > Number(row.ADD_PRODUCT_COUNT)) {
        row.ADD_OUT_COUNT = 0;
        this.$message.show({ text: '出库数量大于库存数量', type: 'warning' });
        return false;
      }
    },
    // --------------------------行
    rowspan() {
      this.tableData.forEach((item, index) => {
        if (index === 0) {
          this.spanArr.push(1);
          this.position = 0;
        } else if (this.tableData[index].ORDER_DETAIL_ID === this.tableData[index - 1].ORDER_DETAIL_ID) {
          this.spanArr[this.position] += 1;
          this.spanArr.push(0);
        } else {
          this.spanArr.push(1);
          this.position = index;
        }
      });
    },
    // ---------------------------------表格合并行
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      if (columnIndex === 0) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 1) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 2) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
      if (columnIndex === 3) {
        const _row = this.spanArr[rowIndex];
        const _col = _row > 0 ? 1 : 0;
        return {
          rowspan: _row,
          colspan: _col,
        };
      }
    },
  },
  created() {
    if (!Object.keys(this.$route.params).length) {
      this.$message.show({ text: '请从历史或全部订单列表(销售)页面进行补出库操作', type: 'warning' });
      this.$router.push({ name: 'welcome' });
      return;
    }

    const { ProductList, ORDER_ID } = this.$route.params;
    this.tableData = ProductList;
    this.orderID = ORDER_ID;
    this.rowspan();
    // 控制是否可以自行修改价格
    if (Number(this.CAN_MODIFY_PRICE) === 1) {
      this.isisdisabled = false;
    } else {
      this.isisdisabled = true;
    }
  },
};
</script>
<style scoped>
.ma img {
  width: 105px;
}

ul {
  list-style: none;
  min-height: 100px;
  padding: 0;
}

li {
  margin-bottom: 0;
  line-height: 25px;
  font-size: 14px;
}

p {
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/sellOrderManage/complementOutWarehouse.vue